__turbopack_context__.v({
  "toastProvider": "ToastProvider-module__I1M2XG__toastProvider",
});
